/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import MiddlePanel from './MiddlePanel';
import RightPanel from './RightPanel';

const rightPanelWidthPercent = 40;

const styles = {
  containerOuter: css`
    width: 100%;
  `,
  container: css`
    position: relative;
    display: flex;
    height: 100%;
    flex-grow: 1;
  `,
  middlePanelContainer: css`
    width: 60%;
    overflow: auto;
  `,
  middlePanelFullContainer: css`
    width: 100%;
  `,
  rightPanelContainer: css`
    width: ${rightPanelWidthPercent}%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-left: 1px solid var(--cds-color-grey-50);
  `,
  navigationContainerInsideRightPanel: css`
    margin-top: auto;
  `,
  navigationContainerOutsideRightPanel: css`
    width: ${rightPanelWidthPercent}%;
    position: absolute;
    bottom: 0;
    right: 0;
    border-left: 1px solid transparent;
  `,
  notificationsGlobalContainer: css`
    position: absolute;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 1000px;
  `,
};

type Props = {
  middlePanelComponent: React.ReactNode;
  rightPanelComponent?: React.ReactNode;
  navigationComponent?: React.ReactNode;
  globalNotificationsComponent?: React.ReactNode;
};

const ContentPanelContainer = ({
  middlePanelComponent,
  rightPanelComponent,
  navigationComponent,
  globalNotificationsComponent,
}: Props) => {
  return (
    <div css={styles.containerOuter}>
      <div css={styles.container}>
        {globalNotificationsComponent && (
          <div css={styles.notificationsGlobalContainer}>{globalNotificationsComponent}</div>
        )}
        <div
          css={[
            styles.middlePanelContainer,
            !rightPanelComponent && styles.middlePanelFullContainer, // override style to full width if right panel not given
          ]}
        >
          <MiddlePanel>{middlePanelComponent}</MiddlePanel>
        </div>
        {rightPanelComponent && (
          <div css={styles.rightPanelContainer}>
            <RightPanel>{rightPanelComponent}</RightPanel>
            {navigationComponent && <div css={styles.navigationContainerInsideRightPanel}>{navigationComponent}</div>}
          </div>
        )}
        {!rightPanelComponent && navigationComponent && (
          <div css={styles.navigationContainerOutsideRightPanel}>{navigationComponent}</div>
        )}
      </div>
    </div>
  );
};

export default ContentPanelContainer;
